module.exports = __webpack_public_path__ + "static/media/cuaderno.bdb60423.svg";